import axios from "axios";
import { CANCELLED_PAYPAL_PAYMENT, CAPTURE_PAYPAL_PAYMENT, CREATE_PAYPAL_PAYMENT, CREATE_STRIPE_PAYMENT, ENROLL_CLASS } from "../env";
export enum WAY {
    PAYPAL = "PAYPAL",
    CARD = "CARD",
}
export type wayType = WAY.CARD | WAY.PAYPAL;

export type ClassEnrollSignUpDto = {
    studentName: string;
    parentName: string;
    parentJob: string;
    parentEmail: string;
    parentPhone: string;
    classType: string;
    time: string;
};
export type ClassEnrollSignUpDtoResponseType = {
    accessToken: string;
    fullName: string;
    userId: string;
};
export type CreatePaypalPaymentDto = {
    items: {
        id: number;
        dateSlotId: number;
        price: number;
        courseType: string;
    }[];
    currency: string;
    courseType?: string;
    promotionCode?: string | null;
    lang: string;
};
export type CreatePaypalPaymentType = {
    orderId: string;
};
export type CreateStripePaymentType = {
    clientSecret: string;
    paymentIntentId: string;
};
export const classEnrollSignUp = async (body: ClassEnrollSignUpDto) => {
    return axios.post<ClassEnrollSignUpDtoResponseType>(ENROLL_CLASS, body);
};
export const createPaypalPayment = async (
    body: CreatePaypalPaymentDto,
    token: string
) => {
    return axios.post<CreatePaypalPaymentType>(CREATE_PAYPAL_PAYMENT, body, {
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        },
    });
};
export const createStripePayment = async (
    body: CreatePaypalPaymentDto,
    token: string
) => {
    return axios.post<CreateStripePaymentType>(CREATE_STRIPE_PAYMENT, body, {
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        },
    });
};
export const capturePaypalPayment = async (
    orderId: number | string,
    token: string
) => {

    return axios.post(`${CAPTURE_PAYPAL_PAYMENT}?orderId=${orderId}`, {}, {
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        },
    });
};
export const canceledPaypalPayment = async (
    orderId: number | string,
    token: string
) => {
    return axios.post(`${CANCELLED_PAYPAL_PAYMENT}?orderId=${orderId}`,{}, {
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        },
    });
};

export const formatDateToMonthDay = (dateString: string) => {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString("en-US", {
        day: "numeric",
        month: "short",
    });
    const [month, day] = formattedDate.split(" ");
    const swappedFormattedDate = `${day} ${month}`;
    return swappedFormattedDate;
};
